import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google'; // Import this
import Dashboard from './dashboard/dashboard';

function App() {
  return (
    // Replace YOUR_GOOGLE_WEB_CLIENT_ID with your actual ID from Google Console
    <GoogleOAuthProvider clientId="606627018623-clml01t39q6lod3lj7uapfu2b1ncnpak.apps.googleusercontent.com">
      <Router>
        <Dashboard />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;